import { Controller } from "@hotwired/stimulus";

export default class LibraryController extends Controller {
  static targets = [
    "editLink",
    "moveLink",
    "showcaseLink",
    "deleteLink"
  ];

  connect() {
    this.handleTurboStream = this.handleTurboStream.bind(this);
    document.addEventListener("turbo:before-stream-render", this.handleTurboStream);
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.handleTurboStream);
  }

  handleTurboStream(event) {
    const stream = event.target;
    if (stream.action === "remove" && stream.target.startsWith("update_attachment_")) {
      this.hideActionIcons();
      this.clearLinks();
    }
  }

  select(event) {
    event.preventDefault();

    const card = event.currentTarget;
    const alreadySelected = card.classList.contains("selected-cases");
    this.clearSelections();

    if (alreadySelected) {
      this.hideActionIcons();
      this.clearLinks();
      return;
    }

    card.classList.add("selected-cases");
    this.showActionIcons();

    const data = this.extractData(card);
    this.updateLinks(data);
  }

  clearSelections() {
    const elements = document.querySelectorAll(".albums-div.selected-cases");

    for (const el of elements) {
      el.classList.remove("selected-cases");
    }
  }

  showActionIcons() {
    const icons = document.querySelectorAll(".library-icon");

    for (const icon of icons) {
      icon.classList.remove("d-none");
    }
  }

  extractData(target) {
    return {
      libraryId: target.dataset.id,
      uploadId: target.dataset.uploadId,
      attachmentId: target.dataset.attachmentId
    };
  }

  updateLinks({ libraryId, uploadId, attachmentId }) {
    this.editLinkTarget.href =
      `/libraries/${libraryId}/edit?upload_id=${uploadId}&attachment_id=${attachmentId}`;

    this.moveLinkTarget.href =
      `/libraries/${libraryId}/move_rack?upload_id=${uploadId}`;

    this.showcaseLinkTarget.href =
      `/showcases/${attachmentId}/new_showcase`;

    this.deleteLinkTarget.href =
      `/libraries/${uploadId}?rack_upload_id=${libraryId}`;
  }

  hideActionIcons() {
    const icons = document.querySelectorAll(".library-icon");

    for (const icon of icons) {
      icon.classList.add("d-none");
    }
  }

  clearLinks() {
    this.editLinkTarget.removeAttribute("href");
    this.moveLinkTarget.removeAttribute("href");
    this.showcaseLinkTarget.removeAttribute("href");
    this.deleteLinkTarget.removeAttribute("href");
  }
}
